<template>

  <div class="logs">

  	<b-modal :active="logModalIsActive" @close="expandedLog = null" :width="720" scroll="keep">
  		<div class="card">
  			<div v-if="logModalIsActive" class="card-content">
  				<template v-if="looksLikeJson(expandedLog.content)">
  					<vue-json-pretty :data="expandedLog.contentJson"></vue-json-pretty>
  				</template>
  				<template v-else>
  					<span class="is-family-monospace is-size-6">{{ expandedLog.content }}</span>
  				</template>
  			</div>
  		</div>
  	</b-modal>

  	<div class="field" style="width: 600px;">
  		<b-input
  			type="search"
  			icon="search"
  			icon-pack="fa"
  			size="is-medium"
  			v-model="search"
  			placeholder="Enter your search ..."
  			:loading="loading"
  			icon-right="close"
            icon-right-clickable
            @icon-right-click="search = ''"
  			:custom-class="(search.length && search.length < 3) ? 'is-warning' : ''">
  		</b-input>
  		<p class="has-text-grey is-7 mt-1">
  			<strong>Tip:</strong>
  			Search for a specific entity type and/or ID plus optional search term.
  			<br>
  			E.g. <code>type:Stormport\Orders\Order id:1234 locked</code>
  		</p>
  	</div>

    <b-table
            :data="decoratedLogs"
            :loading="loading"
            paginated
            backend-pagination
            :total="total"
            height="500"
            :per-page="per_page"
            :current-page="page"
            @page-change="onPageChange"
            sticky-header>

            <template slot-scope="props">

            	<b-table-column field="created_by_name" label="Created By">
	                {{ props.row.created_by_name }}
	            </b-table-column>

	            <b-table-column field="loggableType" label="Entity Type">
	                {{ props.row.loggableType }}
	                <span v-if="props.row.subtype">
	                	<br>
	                	<small class="has-text-grey">{{ props.row.subtype }}</small>
	                </span>
	            </b-table-column>

	            <b-table-column field="loggable_id" label="ID">
	                {{ props.row.loggable_id }}
	            </b-table-column>

	            <b-table-column field="content" label="Content">
	            	<template v-if="looksLikeJson(props.row.content)">
	            		<button @click="expandedLog = props.row" class="button is-info is-small">JSON</button>
	            		{{ props.row.content | truncate(60) }}
	            	</template>
	            	<template v-else>
	            		<button @click="expandedLog = props.row" class="button is-primary is-small">TEXT</button>
	            		{{ props.row.content | truncate(60) }}
	            	</template>
	            </b-table-column>

	            <b-table-column field="created_at" label="Created">
	                {{ props.row.createdAt | toLocalDateAndTime }}
	            </b-table-column>
            </template>

        </b-table>

  </div>

</template>

<script>
import _ from 'lodash/lodash';
import VueJsonPretty from 'vue-json-pretty'
import { LogService } from '@/services/log.service.js';
import { JsonDenormalizer } from '@/helpers/JsonDenormalizer.js';
export default {
	name: 'LogsList',
	components: {
		VueJsonPretty,
	},
	data: function() {
		return {
			logs: [],
			page: 1,
			total: 0,
			search: '',
			per_page: 100,
			loading: false,
			expandedLog: null, // log for viewing in modal
		};
	},
	computed: {
		logModalIsActive() {
			return this.expandedLog && this.expandedLog.id ? true : false;
		},
		decoratedLogs() {
			let logs = [];
			this.logs.forEach(log => {
				let item = Object.assign(
					{},
					log,
					{
						contentJson: this.looksLikeJson(log.content)
							? JSON.parse(log.content)
							: '',
						created_by_name: _.get(log, 'createdBy.fullName', '')
					}
				);
				logs.push(item);
			});
			return logs;
		}
	},
	watch: {
		"search": _.debounce(function () {
			const vm = this;
			// Only allow resetting search or searching with 3+ chars
			if (_.inRange(vm.search.length, 1, 3)) {
				return;
			}
			vm.doSearch();
		}, 500),
	},
	created() {
		const vm = this;
		vm.loading = true;
		this.getRouteData()
			.then(data => {
				const { logs } = data;
				vm.logs = logs;
			})
			.finally(() => {
				vm.loading = false;
			})
	},
	filters: {
		truncate(str, length) {
			length = length || 50;
			return _.truncate(str, { length });
		}
	},
	methods: {
		getRouteData() {
			const vm = this;
			return new Promise((resolve, reject) => {
				Promise.all([
					vm.loadPaginatedLogs(),
				])
				.then(all => {
					return resolve({
						logs: all[0],
					});
				})
			});
		},
		loadPaginatedLogs(params) {
			const vm = this;
			params = _.isPlainObject(params) ? params : {};
			params = Object.assign(
				{},
				{ page: vm.page, per_page: vm.per_page, search: vm.search, includes: 'createdBy' },
				params
			);
			return new Promise((resolve, reject) => {
				vm.getLogs(params)
					.then(res => {
						vm.total = res.meta.pagination.total;
						vm.logs = JsonDenormalizer.denormalize(res);
						return resolve(vm.logs);
					});
			});
		},
		getLogs(params) {
			return LogService.all(params);
		},
		onPageChange(page) {
			const vm = this;
			this.page = page;
			this.loading = true;
			this.loadPaginatedLogs().finally(() => {
				vm.loading = false;
			});
		},
		looksLikeJson(data) {
			const char1 = _.isString(data) ? data.substring(0, 1) : '';
			if (['{', '['].indexOf(char1) >= 0) {
				try {
					const parsed = JSON.parse(data);
					return true;
				}
				catch (err) {}
			}
			return false;
		},
		doSearch: function () {
			const vm = this;
			vm.page = 1;
			vm.loading = true;
			return vm.loadPaginatedLogs().finally(() => {
				vm.loading = false;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Logs/list/index.vue